export enum StepEnum {
  Main = 'main',
  DiamGroupId = 'diamGroupId',
  Models = 'models',
  CompanyCountries = 'companyCountries',
  HfsServiceContractType = 'hfsServiceContractType',
}
export enum CategoryEnum {
  DiamGroupId = StepEnum.DiamGroupId,
  Models = StepEnum.Models,
  CompanyCountries = StepEnum.CompanyCountries,
  HfsServiceContractType = StepEnum.HfsServiceContractType,
}
export type Step =
  | StepEnum.Main
  | StepEnum.DiamGroupId
  | StepEnum.Models
  | StepEnum.CompanyCountries
  | StepEnum.HfsServiceContractType;

export type Category = Exclude<Step, StepEnum.Main>;

export enum GraphTypeEnum {
  BAR = 'BAR',
  LIST = 'LIST',
}

export type FiltersType = {
  models?: string[];
  companyCountries?: string[];
  diamGroupId?: string[];
  hfsServiceContractType?: string[];
};

export enum GroupByTypesEnum {
  ACTIVITY = 'ACTIVITY',
  FIRMWARE_UPDATE_STATUS = 'FIRMWARE_UPDATE_STATUS',
  OPERATIONAL_STATUS = 'OPERATIONAL_STATUS',
  SERVICES_BY_HUSQVARNA = 'SERVICES_BY_HUSQVARNA',
  SERVICES_EXPIRY_STATUS = 'SERVICES_EXPIRY_STATUS',
}

export interface GroupByStatusIconConfig {
  type: string;
  color?: string;
}
